import { render, staticRenderFns } from "./DetalhesManage.vue?vue&type=template&id=7a03f610&scoped=true"
import script from "./DetalhesManage.vue?vue&type=script&lang=js"
export * from "./DetalhesManage.vue?vue&type=script&lang=js"
import style0 from "./DetalhesManage.vue?vue&type=style&index=0&id=7a03f610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a03f610",
  null
  
)

export default component.exports